import { cn } from "@/lib/chillnn/cn";

import type { ForNodeType } from "@/components/features/_model/types";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

type Props = {
	useAsSubOption: ForNodeType<boolean>;
	onSetUseAsSubOption: (input: boolean) => void;
};

export const QuestionOptionUseAsSubOption = ({ useAsSubOption, onSetUseAsSubOption }: Props) => {
	return (
		<div className={cn(Boolean(useAsSubOption.error) && "mb-8")}>
			<CheckboxField
				value={useAsSubOption.value}
				label={"サブオプションを設定する"}
				handleChange={onSetUseAsSubOption}
				errorMessage={useAsSubOption.error}
			/>
		</div>
	);
};

QuestionOptionUseAsSubOption.displayName = "QuestionOptionUseAsSubOption";
